import { useEffect } from "react";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Input from "../../components/Input";
import Modal from "../../components/Modal";
import theme from "../../styles/theme";
import Status from "../../types/enum/Status";

export const CompetencyFilterModal = (
  {
    isOpen,
    modalHeader,
    filterData,
    myCompetencyChecked,
    mobile,
    filters,
    inset,
    setOpen,
    confirmFunction,
    isCodeFiltered,
    setIsCodeFiltered,
    setFilterCode,
    filterCode,
    tempFilterCode,
    setTempFilterCode,
  }: any) => {
  useEffect(() => {
    if (isOpen) {
      // Use setTimeout to delay the focus
      const timer = setTimeout(() => {
        const inputElement = document.getElementById("competency_code");
        if (inputElement) {
          inputElement.focus();
        }
      }, 1); // Adjust the timeout as necessary

      return () => clearTimeout(timer); // Cleanup on unmount or when isOpen changes
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen || false}
      onClose={() => setFilterCode(tempFilterCode)}
      setOpen={setOpen}
      customStyle={{
        overlay: {
          background: "unset",
        },
        content: {
          maxWidth: mobile ? "300px" : "360px",
          width: "100%",
          height: "auto",
          padding: "16px 16px 24px 16px",
          background: "#1a1d2d",
          // backdropFilter: 'blur(35px)',
          boxShadow: "0 0 4px black",
          position: "absolute",
          inset: inset || "0px 0px auto auto",
          margin: `calc(${theme.navbarHeight} + ${theme.spacing.x10} + 70px) 2% auto calc(${theme.spacing.x4} + 255px)`,
        },
      }}
    >
      <div>
        {isCodeFiltered && (
          <div
            onClick={() => {
              const index: any = [];
              filterData.forEach((element: any) => {
                index.push(element.value);
              });
              setOpen(false);
              setIsCodeFiltered(false);
              setFilterCode("");
              setTempFilterCode("");
            }}
            style={{
              color: "#f7b53a",
              display: "flex",
              alignItems: "center",
              flexWrap: "nowrap",
              marginBottom: 5,
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
          >
            <ClickableIcon onClick={() => {}} color="#f7b53a" name="times" />
            <div style={{ display: "flex", flexWrap: "nowrap" }}>
              Remove Filter
            </div>
          </div>
        )}
        <Input
          onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFilterCode(e.target.value.toUpperCase());
          }}
          required
          isFullWidth
          id="competency_code"
          name="competency_code"
          placeholder="Competency Code"
          value={filterCode}
          style={{ color: "white" }}
        />
        <FlexBox
          justify="end"
          style={{ marginTop: "16px", flexWrap: "nowrap" }}
        >
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: mobile ? "150px" : "150px",
                height: "40px",
                padding: "13px 12px",
              }}
              isOutline
              onClick={() => {
                setOpen(false);
                setFilterCode(tempFilterCode);
              }}
              status={Status.default}
            >
              Cancel
            </Button>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: mobile ? "150px" : "150px",
                height: "40px",
                padding: "13px 12px",
              }}
              status={Status.button}
              onClick={() => {
                confirmFunction();
                setOpen(false);
                setIsCodeFiltered(true);
                setTempFilterCode(filterCode);
              }}
            >
              Apply
            </Button>
          </FlexGrow>
        </FlexBox>
      </div>
    </Modal>
  );
};
